// import InputField from "components/fields/InputField";
// import { FcGoogle } from "react-icons/fc";
// import Checkbox from "components/checkbox";
import { useState } from "react";
import useRegisterFormContext from "hooks/useRegisterFormContext";
import RegisterFormInputs from "./Register/RegisterFormInputs";
import { useMutation } from "@apollo/client"
import { CREATE_USER_MUTATION } from "graphql/auth/mutations"
import ErrorAlert from "components/ErrorAlert";
import SuccessAlert from "components/SuccessAlert";
import { useNavigate } from "react-router-dom";
export default function Register() {

  const navigate = useNavigate()

  const [createUser] = useMutation(CREATE_USER_MUTATION);
  // console.log("GraphQL Query:", CREATE_USER_MUTATION?.loc?.source?.body);

  const {
    // page,
    setPage,
    data,
    // title,
    canSubmit,
    disablePrev,
    disableNext,
    prevHide,
    nextHide,
    submitHide
  } = useRegisterFormContext()

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // console.log(disablePrev, disableNext);

  const handlePrev = () => setPage(prev => prev - 1)

  const handleNext = () => setPage(prev => prev + 1)
  const handleSubmit = e => {
    e.preventDefault()
    setIsSubmitting(true);
    setError('');
    setSuccess('');
    
    createUser({
      variables: {
        createUserInput: {
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          phone_number: data.phoneNumber,
          password: data.password,
          country: data.country,
        },
      },
    })
      .then((response) => {
        setIsSubmitting(false);
        setSuccess(`Registration successful! Please check your email (${data.email}) to verify your account. Check your spam folder if you don't see the email.`);
        
        setTimeout(() => {
          navigate('/auth/sign-in')
        }, 5000);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error Encountered: ", error);
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          const errorMessage = error.graphQLErrors[0]?.message;
          if (errorMessage) {
            setError(errorMessage);
          } else {
            setError('An error occurred during registration. Please try again.');
          }
        } else {
          setError(error.message || 'Network error. Please check your connection and try again.');
        }
      });
  }

  const onClose = () => {
      setError('');
  }

  const onSuccessClose = () => {
      setSuccess('');
  }

  return (
    <form className="form flex-col" onSubmit={handleSubmit}>

      {error && <ErrorAlert message={error} onClose={onClose} />}
      {success && <SuccessAlert message={success} onClose={onSuccessClose} />}

      {/* <header className="form-header">
        <h2>{title[page]}</h2>

        <div className="button-container">

          <button type="button" className={`button ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>Prev</button>

          <button type="button" className={`button ${nextHide}`} onClick={handleNext} disabled={disableNext}>Next</button>

          <button type="submit" className={`button ${submitHide}`} disabled={!canSubmit}>Submit</button>
        </div>
      </header> */}
      <div className="flex flex-col-reverse lg:flex-row items-center justify-between w-full">
        <div className="m-8 w-full max-w-full flex-col items-center lg:max-w-[420px]">
          <RegisterFormInputs />
          <div className="button-container gap-4 w-full max-w-full flex items-center xl:max-w-[420px]">

            <button
              className={`
            linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 
            ${prevHide}
          `}
              type="button"
              onClick={handlePrev}
              disabled={disablePrev}
            >
              Prev
            </button>

            <div className="relative w-full group">
              <button
                className={`
                  linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200
                  ${nextHide}
                  ${disableNext ? 'opacity-50 cursor-not-allowed' : ''}
                `}
                onClick={handleNext}
                disabled={disableNext}
              >
                Next
              </button>
              {disableNext && !nextHide && (
                <div className="hidden group-hover:block absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-3 py-2 bg-gray-800 text-white text-sm rounded shadow-lg whitespace-nowrap z-10">
                  Please fill in First Name and Last Name
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                </div>
              )}
            </div>

            <div className="relative w-full group">
              <button
                className={`
                  linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200
                  ${submitHide}
                  ${!canSubmit ? 'opacity-50 cursor-not-allowed' : ''}
                  ${isSubmitting ? 'opacity-75 cursor-wait' : ''}
                `}
                type="submit"
                disabled={!canSubmit || isSubmitting}
              >
                {isSubmitting ? 'Registering...' : 'Register'}
              </button>
              {!canSubmit && !submitHide && (
                <div className="hidden group-hover:block absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-3 py-2 bg-gray-800 text-white text-sm rounded shadow-lg whitespace-nowrap z-10">
                  Please fill in all required fields (marked with *)
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                </div>
              )}
            </div>
            {/* <button type="button" className={`button ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>Prev</button>

        <button type="button" className={`button ${nextHide}`} onClick={handleNext} disabled={disableNext}>Next</button>

        <button type="submit" className={`button ${submitHide}`} disabled={!canSubmit}>Submit</button> */}
          </div>
        </div>
        <div>
          <img src="/Images/login_page.png" />
        </div>
      </div>
    </form>
  );
}
